import { render, staticRenderFns } from "./wizardStep1.vue?vue&type=template&id=4c060b4c&scoped=true&"
import script from "./wizardStep1.vue?vue&type=script&lang=js&"
export * from "./wizardStep1.vue?vue&type=script&lang=js&"
import style0 from "./wizardStep1.vue?vue&type=style&index=0&id=4c060b4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c060b4c",
  null
  
)

export default component.exports